import { IS_DEVELOPMENT, WEBSITE_SETTINGS } from '@/client/settings'

// WEBAPP_BASE_URL overrides the default URL derived from SHW_ENV.
// This enables deploying to custom domains (e.g., webapp--staging.dev.internal.schoolhouse.world)
// without changing SHW_ENV, which controls other environment-specific settings.
// Injected at runtime via __SHW_ENV__ (client) or process.env (server).
// eslint-disable-next-line no-underscore-dangle
const baseUrlOverride = globalThis.__SHW_ENV__?.WEBAPP_BASE_URL ?? process.env.WEBAPP_BASE_URL ?? ''

export const WEBSITE_URL =
  baseUrlOverride !== ''
    ? baseUrlOverride
    : `${IS_DEVELOPMENT ? 'http://' : 'https://'}${WEBSITE_SETTINGS.websiteName}`

export const SHARE_BUTTON_REF_CODE = 'share-button'
